export default "__VITE_ASSET__CyVcjFeG__"